module.exports = __webpack_public_path__ + "static/media/MasterCard.dc6016cd.svg";